package com.arena_web.navigation

object Routes {

    const val HOME = "/"

    const val LOGIN = "/login"
    const val REGISTER = "/register"
    const val FORGOT_PASSWORD = "/forgot-password"

    const val PROFILE = "/profile"
    const val USER_PROFILE = "/profile/{id}"
    const val EDIT_PROFILE = "/profile/edit"

    const val EVENTS = "/events"
    const val EVENT_DETAILS = "/events/{id}"
    const val CREATE_EVENT = "/events/create"

    const val GROUPS = "/groups"
    const val GROUP_DETAILS = "/groups/{id}"
    const val CREATE_GROUP = "/groups/create"

    const val CHAT = "/chat"
    const val CHAT_ROOM = "/chat/{id}"

    const val DASHBOARD = "/dashboard"
    const val CLIENTS = "/clients"
    const val SCHEDULE = "/schedule"

    const val VS = "/vs"
    const val ARENA = "/arena"
    const val CLUB_DETAIL = "/clubs/{id}"

    const val NEWS = "/news"
    const val NEWS_DETAILS = "/news/{id}"

    const val SETTINGS = "/settings"

    fun userProfile(userId: String): String {
        return USER_PROFILE.replace("{id}", userId)
    }

    fun eventDetails(eventId: String): String {
        return EVENT_DETAILS.replace("{id}", eventId)
    }

    fun groupDetails(groupId: String): String {
        return GROUP_DETAILS.replace("{id}", groupId)
    }

    fun chatRoom(chatId: String): String {
        return CHAT_ROOM.replace("{id}", chatId)
    }

    fun schedule(): String = SCHEDULE

    fun clubDetail(clubId: String): String {
        return CLUB_DETAIL.replace("{id}", clubId)
    }

    fun newsDetails(newsId: String): String {
        return NEWS_DETAILS.replace("{id}", newsId)
    }

    fun extractId(route: String, pattern: String): String? {
        val patternParts = pattern.split("/")
        val routeParts = route.split("/")

        if (patternParts.size != routeParts.size) return null

        for (i in patternParts.indices) {
            if (patternParts[i].startsWith("{") && patternParts[i].endsWith("}")) {
                return routeParts[i]
            }
        }

        return null
    }
}
